import React, { useState, useEffect } from 'react';
import { supabase } from './supabase';

// 0532 123 45 67
const formatTelefon = (val) => {
  const temiz = val.replace(/\D/g, '').slice(0, 11);
  let r = temiz.slice(0, 4);
  if (temiz.length > 4) r += ' ' + temiz.slice(4, 7);
  if (temiz.length > 7) r += ' ' + temiz.slice(7, 9);
  if (temiz.length > 9) r += ' ' + temiz.slice(9, 11);
  return r;
};

function Musteriler() {
  const [musteriler, setMusteriler] = useState([]);
  const [aramaMetni, setAramaMetni] = useState('');
  const [yukleniyor, setYukleniyor] = useState(true);
  const [yeniMusteri, setYeniMusteri] = useState({ ad: '', tip: 'Bireysel', ulke: 'KKTC', telefon: '', email: '', sehir: '' });
  const [formAcik, setFormAcik] = useState(false);
  const [duzenleModal, setDuzenleModal] = useState(null);
  const [secilenMusteriler, setSecilenMusteriler] = useState(new Set());
  const [borclar, setBorclar] = useState({});

  useEffect(() => {
    musterilerGetir();
    borclarGetir();
  }, []);

  const musterilerGetir = async () => {
    setYukleniyor(true);
    const { data, error } = await supabase
      .from('musteriler')
      .select('*')
      .order('created_at', { ascending: false });
    if (error) console.error('Hata:', error);
    else setMusteriler(data);
    setYukleniyor(false);
  };

  const borclarGetir = async () => {
    const { data } = await supabase
      .from('odemeler')
      .select('musteri_id, toplam_tutar, odenen_tutar')
      .neq('odeme_durumu', 'Tamamlandı');
    if (!data) return;
    const map = {};
    data.forEach(o => {
      const kalan = (o.toplam_tutar || 0) - (o.odenen_tutar || 0);
      map[o.musteri_id] = (map[o.musteri_id] || 0) + kalan;
    });
    setBorclar(map);
  };

  const musteriEkle = async () => {
    if (!yeniMusteri.ad) return alert('Müşteri adı zorunlu!');
    const { error } = await supabase.from('musteriler').insert([{ ...yeniMusteri }]);
    if (error) { alert('Hata: ' + error.message); return; }
    setFormAcik(false);
    setYeniMusteri({ ad: '', tip: 'Bireysel', ulke: 'KKTC', telefon: '', email: '', sehir: '' });
    musterilerGetir();
  };

  const musteriGuncelle = async () => {
    if (!duzenleModal.ad) return alert('Müşteri adı zorunlu!');
    const { error } = await supabase.from('musteriler').update({
      ad: duzenleModal.ad, tip: duzenleModal.tip, ulke: duzenleModal.ulke,
      telefon: duzenleModal.telefon, email: duzenleModal.email,
      sehir: duzenleModal.sehir, durum: duzenleModal.durum,
    }).eq('id', duzenleModal.id);
    if (error) { alert('Hata: ' + error.message); return; }
    setDuzenleModal(null);
    musterilerGetir();
  };

  const musteriSil = async (id, ad) => {
    if (!window.confirm(`"${ad}" müşterisini silmek istediğinize emin misiniz?`)) return;
    const { error } = await supabase.from('musteriler').delete().eq('id', id);
    if (error) { alert('Hata: ' + error.message); return; }
    musterilerGetir();
  };

  const topluSil = async () => {
    if (!window.confirm(`${secilenMusteriler.size} müşteriyi silmek istediğinize emin misiniz?`)) return;
    const { error } = await supabase.from('musteriler').delete().in('id', [...secilenMusteriler]);
    if (error) { alert('Hata: ' + error.message); return; }
    setSecilenMusteriler(new Set());
    musterilerGetir();
  };

  const musteriSec = (id) => {
    setSecilenMusteriler(prev => {
      const yeni = new Set(prev);
      if (yeni.has(id)) yeni.delete(id); else yeni.add(id);
      return yeni;
    });
  };

  const tumunuSec = () => {
    if (secilenMusteriler.size === filtrelenmis.length) setSecilenMusteriler(new Set());
    else setSecilenMusteriler(new Set(filtrelenmis.map(m => m.id)));
  };

  const filtrelenmis = musteriler.filter(m =>
    m.ad.toLowerCase().includes(aramaMetni.toLowerCase())
  );

  const tumSecili = filtrelenmis.length > 0 && secilenMusteriler.size === filtrelenmis.length;

  return (
    <div style={{ flex: 1, background: '#f5f5f5', display: 'flex', flexDirection: 'column', fontFamily: 'Arial, sans-serif' }}>

      <div style={{ background: '#fff', padding: '14px 24px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ fontSize: '18px', fontWeight: '600' }}>Müşteriler</div>
        <button onClick={() => setFormAcik(!formAcik)}
          style={{ background: '#0D3B7A', color: '#fff', border: 'none', padding: '8px 18px', borderRadius: '8px', fontSize: '13px', cursor: 'pointer', fontWeight: '600' }}>
          {formAcik ? '✕ Kapat' : '+ Yeni Müşteri'}
        </button>
      </div>

      <div style={{ padding: '24px' }}>

        {/* Yeni Müşteri Formu */}
        {formAcik && (
          <div style={{ background: '#fff', borderRadius: '10px', border: '1px solid #ddd', padding: '20px', marginBottom: '20px' }}>
            <div style={{ fontSize: '14px', fontWeight: '600', marginBottom: '16px', color: '#0D3B7A' }}>Yeni Müşteri Ekle</div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '12px', marginBottom: '12px' }}>
              <div>
                <div style={{ fontSize: '12px', fontWeight: '500', marginBottom: '6px' }}>Ad Soyad / Firma Adı *</div>
                <input value={yeniMusteri.ad} onChange={e => setYeniMusteri({ ...yeniMusteri, ad: e.target.value })}
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box' }} />
              </div>
              <div>
                <div style={{ fontSize: '12px', fontWeight: '500', marginBottom: '6px' }}>Tip</div>
                <select value={yeniMusteri.tip} onChange={e => setYeniMusteri({ ...yeniMusteri, tip: e.target.value })}
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px' }}>
                  <option>Bireysel</option>
                  <option>Kurumsal</option>
                </select>
              </div>
              <div>
                <div style={{ fontSize: '12px', fontWeight: '500', marginBottom: '6px' }}>Hedef Ülke</div>
                <select value={yeniMusteri.ulke} onChange={e => setYeniMusteri({ ...yeniMusteri, ulke: e.target.value })}
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px' }}>
                  <option>KKTC</option>
                  <option>Montenegro</option>
                </select>
              </div>
              <div>
                <div style={{ fontSize: '12px', fontWeight: '500', marginBottom: '6px' }}>Şehir</div>
                <input value={yeniMusteri.sehir} onChange={e => setYeniMusteri({ ...yeniMusteri, sehir: e.target.value })}
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box' }} />
              </div>
              <div>
                <div style={{ fontSize: '12px', fontWeight: '500', marginBottom: '6px' }}>Telefon</div>
                <input value={yeniMusteri.telefon} onChange={e => setYeniMusteri({ ...yeniMusteri, telefon: formatTelefon(e.target.value) })}
                  placeholder="0532 123 45 67"
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box' }} />
              </div>
              <div>
                <div style={{ fontSize: '12px', fontWeight: '500', marginBottom: '6px' }}>E-posta</div>
                <input value={yeniMusteri.email} onChange={e => setYeniMusteri({ ...yeniMusteri, email: e.target.value })}
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box' }} />
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <button onClick={() => setFormAcik(false)} style={{ padding: '8px 18px', border: '1px solid #ddd', borderRadius: '6px', background: '#fff', cursor: 'pointer' }}>Vazgeç</button>
              <button onClick={musteriEkle} style={{ padding: '8px 20px', background: '#0D3B7A', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '600' }}>Kaydet</button>
            </div>
          </div>
        )}

        {/* Metrikler */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px', marginBottom: '20px' }}>
          {[
            { label: 'Toplam Müşteri', value: musteriler.length, color: '#185FA5' },
            { label: 'Aktif Müşteri', value: musteriler.filter(m => m.durum === 'Aktif').length, color: '#3B6D11' },
            { label: 'KKTC', value: musteriler.filter(m => m.ulke === 'KKTC').length, color: '#854F0B' },
          ].map((card, i) => (
            <div key={i} style={{ background: '#fff', borderRadius: '10px', padding: '16px', border: '1px solid #eee' }}>
              <div style={{ fontSize: '12px', color: '#888', marginBottom: '6px' }}>{card.label}</div>
              <div style={{ fontSize: '28px', fontWeight: '700', color: '#1a1a1a' }}>{card.value}</div>
            </div>
          ))}
        </div>

        {/* Liste */}
        <div style={{ background: '#fff', borderRadius: '10px', border: '1px solid #eee', overflow: 'hidden' }}>
          <div style={{ padding: '14px 20px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '12px' }}>
            <div style={{ fontSize: '14px', fontWeight: '600', whiteSpace: 'nowrap' }}>Tüm Müşteriler ({filtrelenmis.length})</div>
            {secilenMusteriler.size > 0 && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', background: '#FEF2F2', border: '1px solid #FECACA', borderRadius: '8px', padding: '6px 14px' }}>
                <span style={{ fontSize: '12px', color: '#991B1B', fontWeight: '600' }}>{secilenMusteriler.size} seçili</span>
                <button onClick={topluSil} style={{ background: '#DC2626', color: '#fff', border: 'none', padding: '4px 12px', borderRadius: '6px', fontSize: '12px', cursor: 'pointer', fontWeight: '600' }}>Toplu Sil</button>
                <button onClick={() => setSecilenMusteriler(new Set())} style={{ background: 'none', border: 'none', color: '#888', fontSize: '16px', cursor: 'pointer', lineHeight: 1 }}>✕</button>
              </div>
            )}
            <input placeholder="Müşteri ara..." value={aramaMetni} onChange={e => setAramaMetni(e.target.value)}
              style={{ padding: '6px 12px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '12px', width: '200px' }} />
          </div>

          {yukleniyor ? (
            <div style={{ padding: '40px', textAlign: 'center', color: '#888' }}>Yükleniyor...</div>
          ) : filtrelenmis.length === 0 ? (
            <div style={{ padding: '40px', textAlign: 'center', color: '#888' }}>Henüz müşteri yok.</div>
          ) : (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                <thead>
                  <tr style={{ background: '#f9f9f9' }}>
                    <th style={{ padding: '10px 14px', width: '40px' }}>
                      <input type="checkbox" checked={tumSecili} onChange={tumunuSec} style={{ cursor: 'pointer' }} />
                    </th>
                    {['Müşteri Adı', 'Tip', 'Ülke', 'Telefon', 'E-posta', 'Durum', 'Açık Borç', ''].map((h, i) => (
                      <th key={i} style={{ padding: '10px 16px', textAlign: 'left', color: '#888', fontWeight: '500', fontSize: '12px', whiteSpace: 'nowrap' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {filtrelenmis.map((row) => (
                    <tr key={row.id} style={{ borderTop: '1px solid #eee', background: secilenMusteriler.has(row.id) ? '#EFF6FF' : 'transparent' }}>
                      <td style={{ padding: '10px 14px' }}>
                        <input type="checkbox" checked={secilenMusteriler.has(row.id)} onChange={() => musteriSec(row.id)} style={{ cursor: 'pointer' }} />
                      </td>
                      <td style={{ padding: '12px 16px', fontWeight: '600', color: '#0D3B7A' }}>{row.ad}</td>
                      <td style={{ padding: '12px 16px' }}>
                        <span style={{ background: row.tip === 'Kurumsal' ? '#E3F0FF' : '#EAF3DE', color: row.tip === 'Kurumsal' ? '#0D3B7A' : '#3B6D11', padding: '2px 8px', borderRadius: '10px', fontSize: '11px', fontWeight: '600' }}>{row.tip}</span>
                      </td>
                      <td style={{ padding: '12px 16px', color: '#555' }}>{row.ulke}</td>
                      <td style={{ padding: '12px 16px', color: '#555' }}>{row.telefon}</td>
                      <td style={{ padding: '12px 16px', color: '#555' }}>{row.email}</td>
                      <td style={{ padding: '12px 16px' }}>
                        <span style={{ background: '#EAF3DE', color: '#3B6D11', padding: '2px 8px', borderRadius: '10px', fontSize: '11px', fontWeight: '600' }}>{row.durum}</span>
                      </td>
                      <td style={{ padding: '12px 16px', whiteSpace: 'nowrap' }}>
                        {borclar[row.id] > 0 ? (
                          <span style={{ background: '#FEE2E2', color: '#DC2626', padding: '3px 10px', borderRadius: '20px', fontSize: '12px', fontWeight: '700' }}>
                            {new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2 }).format(borclar[row.id])} ₺
                          </span>
                        ) : (
                          <span style={{ background: '#EAF3DE', color: '#3B6D11', padding: '3px 10px', borderRadius: '20px', fontSize: '12px', fontWeight: '600' }}>✓ Temiz</span>
                        )}
                      </td>
                      <td style={{ padding: '12px 16px', whiteSpace: 'nowrap' }}>
                        <button onClick={() => setDuzenleModal({ ...row })}
                          style={{ background: '#f0f4ff', color: '#0D3B7A', border: '1px solid #c7d7f5', padding: '4px 10px', borderRadius: '6px', fontSize: '11px', cursor: 'pointer', marginRight: '6px', fontWeight: '600' }}>
                          Düzenle
                        </button>
                        <button onClick={() => musteriSil(row.id, row.ad)}
                          style={{ background: '#fff0f0', color: '#DC2626', border: '1px solid #fecaca', padding: '4px 10px', borderRadius: '6px', fontSize: '11px', cursor: 'pointer', fontWeight: '600' }}>
                          Sil
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* Düzenle Modal */}
      {duzenleModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: '12px', padding: '24px', width: '520px', fontFamily: 'Arial, sans-serif' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <div style={{ fontSize: '16px', fontWeight: '600', color: '#0D3B7A' }}>Müşteri Düzenle</div>
              <button onClick={() => setDuzenleModal(null)} style={{ background: 'none', border: 'none', fontSize: '18px', cursor: 'pointer', color: '#888' }}>✕</button>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '20px' }}>
              <div style={{ gridColumn: '1 / -1' }}>
                <div style={{ fontSize: '12px', fontWeight: '500', marginBottom: '6px' }}>Ad Soyad / Firma Adı *</div>
                <input value={duzenleModal.ad} onChange={e => setDuzenleModal({ ...duzenleModal, ad: e.target.value })}
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box' }} />
              </div>
              <div>
                <div style={{ fontSize: '12px', fontWeight: '500', marginBottom: '6px' }}>Tip</div>
                <select value={duzenleModal.tip} onChange={e => setDuzenleModal({ ...duzenleModal, tip: e.target.value })}
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px' }}>
                  <option>Bireysel</option>
                  <option>Kurumsal</option>
                </select>
              </div>
              <div>
                <div style={{ fontSize: '12px', fontWeight: '500', marginBottom: '6px' }}>Hedef Ülke</div>
                <select value={duzenleModal.ulke} onChange={e => setDuzenleModal({ ...duzenleModal, ulke: e.target.value })}
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px' }}>
                  <option>KKTC</option>
                  <option>Montenegro</option>
                </select>
              </div>
              <div>
                <div style={{ fontSize: '12px', fontWeight: '500', marginBottom: '6px' }}>Şehir</div>
                <input value={duzenleModal.sehir || ''} onChange={e => setDuzenleModal({ ...duzenleModal, sehir: e.target.value })}
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box' }} />
              </div>
              <div>
                <div style={{ fontSize: '12px', fontWeight: '500', marginBottom: '6px' }}>Telefon</div>
                <input value={duzenleModal.telefon || ''} onChange={e => setDuzenleModal({ ...duzenleModal, telefon: formatTelefon(e.target.value) })}
                  placeholder="0532 123 45 67"
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box' }} />
              </div>
              <div>
                <div style={{ fontSize: '12px', fontWeight: '500', marginBottom: '6px' }}>E-posta</div>
                <input value={duzenleModal.email || ''} onChange={e => setDuzenleModal({ ...duzenleModal, email: e.target.value })}
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box' }} />
              </div>
              <div>
                <div style={{ fontSize: '12px', fontWeight: '500', marginBottom: '6px' }}>Durum</div>
                <select value={duzenleModal.durum || 'Aktif'} onChange={e => setDuzenleModal({ ...duzenleModal, durum: e.target.value })}
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px' }}>
                  <option>Aktif</option>
                  <option>Pasif</option>
                </select>
              </div>
            </div>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
              <button onClick={() => setDuzenleModal(null)} style={{ padding: '8px 18px', border: '1px solid #ddd', borderRadius: '6px', background: '#fff', cursor: 'pointer' }}>İptal</button>
              <button onClick={musteriGuncelle} style={{ padding: '8px 20px', background: '#0D3B7A', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '600' }}>Kaydet</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Musteriler;
